module.exports = __webpack_public_path__ + "img/bg.0f8c63b1.png";